// extracted by mini-css-extract-plugin
module.exports = {"checkmark":"checkmark_checkmark__3F7-o","selected":"checkmark_selected__35nbA"};